import React, { lazy } from "react";
import { Switch, Route } from "react-router-dom";
import { useRouteMatch } from "react-router-dom/cjs/react-router-dom.min";

const CRMDashboard = lazy(() => import("../../container/dashboard/CRM"));
const QuotesList = lazy(() => import("../../container/pages/quotes/index"));

function DashboardRoutes() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={path} component={QuotesList} />
    </Switch>
  );
}

export default DashboardRoutes;
